import React, { useEffect, RefObject, createRef, useState } from 'react';
import { _OldChat } from '../models';

import Loader from '../../assets/icons/loader.svg';
import BackToTop from '../../assets/icons/back-to-top.svg';
import Whatsapp_channel from '../../assets/icons/whatsapp_channel.svg';
import Webs_channel from '../../assets/icons/webs_channel.svg';
import './EndedChats.scss';

type EndedChatsPropsType = {
  // oldChats: _OldChat[];
  oldChats: any;
  selectedOldChatIndex: number | any;
  groupAll: Function;
  oldChatsExhausted: boolean;
  isOldChatsLoading: boolean;
  clearDateFilter: Function;
  clearDateFilterValue: boolean;
  getGroupingFormatDate: Function;
  onPageChange: () => void;
  onClick: (
    index: number | any,
    sessionID: string,
    ipaddress: string,
    s_id: number,
    botIconUrl: string,
    botName: string,
    customerName: string,
    type: string,
    status: string,
    feedback?: string,
    channel?: string,
    deviceInfo?: string,
    handoff_id?: string,
    time?: string
  ) => void;
};

const EndedChats = (props: EndedChatsPropsType) => {
  const [isBackToTopVisible, setIsBackToTopVisible] = useState(false);

  const EndedChatsRef: RefObject<HTMLDivElement> = createRef();
  const getFormattedDate = (time: string) => {
    const date = new Date(time);
    let hours = date.getHours();
    let minutes: number | string = date.getMinutes();
    let ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
  };

  const handleScroll = (e: Event) => {
    const target = e.target as HTMLDivElement;

    if (target.scrollTop >= 72) {
      setIsBackToTopVisible(true);
    } else {
      setIsBackToTopVisible(false);
    }
    let ceiloffset = Math.ceil(target.scrollTop) + target.offsetHeight;
    let flooroffset = Math.floor(target.scrollTop) + target.offsetHeight;

    if (ceiloffset >= target.scrollHeight || flooroffset >= target.scrollHeight) {
      props.onPageChange();
    }
  };
  const backToTop = () => {
    if (EndedChatsRef.current) {
      EndedChatsRef.current.scroll({
        top: 0,
        behavior: 'smooth',
      });
    }
  };
  useEffect(() => {
    if (EndedChatsRef.current) {
      EndedChatsRef.current.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (EndedChatsRef.current) {
        document.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);
  return (
    // <div style={{ width: '100%', height: '100%' }}>
    <div style={{ width: '100%', height: '75%' }}>
      <span
        style={props.clearDateFilterValue === true ? { display: 'none' } : {}}
        className='clear-filter-chats'
        onClick={() => props.clearDateFilter()}>
        Clear filters
      </span>
      <div ref={EndedChatsRef} className='ended-chats-wrapper'>
        {Object.values(props.oldChats).length > 0 ? (
          Object.values(props.oldChats).length > 0 &&
          Object.values(props.oldChats).map((key: any, index) => {
            return (
              <>
                <span className='grouping-date'>
                  {props.getGroupingFormatDate(Object.keys(key)[0], 'EndedChats')}
                </span>
                {props.oldChats[index][Object.keys(key)[0]] &&
                  props.oldChats[index][Object.keys(key)[0]].map((o: any, i: number) => {
                    return (
                      <div
                        key={`${index}_${i}`}
                        className={`ended-chat ${
                          props.selectedOldChatIndex === `${index}_${i}` ||
                          (props.selectedOldChatIndex === 0 &&
                            props.selectedOldChatIndex === index &&
                            props.selectedOldChatIndex === i)
                            ? 'selected'
                            : ''
                        }`}
                        onClick={() =>
                          props.onClick(
                            `${index}_${i}`,
                            o.session,
                            o.ipaddress,
                            o.s_id,
                            o.botIconURL,
                            o.botName,
                            o.customerName,
                            o.type,
                            o.status,
                            o.feedback,
                            o.channel,
                            o.deviceInfo,
                            o.handoff_id,
                            o.time
                          )
                        }>
                        <div style={{ display: 'flex' }}>
                          <div className='bot-icon'>
                            <img src={o.botIconURL} alt={o.botName} />
                          </div>
                          <div className='details'>
                            <div style={{ display: 'flex' }}>
                              <img
                                src={
                                  o.channel === 'webs'
                                    ? Webs_channel
                                    : o.channel === 'whatsapp' || o.channel === 'WhatsApp'
                                    ? Whatsapp_channel
                                    : ''
                                }
                                alt=''
                                style={{ width: '20px', height: '20px' }}
                                title={
                                  o.channel === 'webs' &&
                                  (o.deviceInfo === null ||
                                    o.deviceInfo === '-' ||
                                    o.deviceInfo === '' ||
                                    o.deviceInfo === undefined)
                                    ? 'Web'
                                    : o.channel === 'webs'
                                    ? `Web ${
                                        o.deviceInfo !== null ||
                                        o.deviceInfo !== '' ||
                                        o.deviceInfo !== undefined
                                          ? '(' + o.deviceInfo + ')'
                                          : ''
                                      }`
                                    : o.channel === 'whatsapp'
                                    ? 'WhatsApp'
                                    : o.channel
                                }
                              />

                              <div
                                className='customer-name'
                                style={{ marginLeft: '2px' }}>
                                {o.customerName}
                              </div>
                            </div>
                            <div className='bot-queue-name' style={{ marginTop: '6px' }}>
                              {o.botName} : {o.type}
                            </div>
                            <div className='status-feedback-area'>
                              {o.status && (
                                <div className='status' data-status={o.status}>
                                  {o.status}
                                </div>
                              )}
                              {o.feedback && (
                                <div
                                  className='feedback'
                                  data-feedback={o.feedback}
                                  style={
                                    o.status === undefined ? { marginLeft: '0px' } : {}
                                  }>
                                  {o.feedback}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div>
                          <div className='time'>{getFormattedDate(o.time)}</div>
                        </div>
                      </div>
                    );
                  })}
              </>
            );
          })
        ) : (
          <div
            style={{ margin: 'auto', paddingBottom: '35px' }}
            className='endchats-no-handoffs-error'>
            No handoffs in the selected date range
          </div>
        )}

        {/* : (
          <div style={{ margin: 'auto', paddingBottom: '35px' }} className="endchats-no-handoffs-error">
            No handoffs in the selected date range
          </div>
        )
        } */}
        {!props.oldChatsExhausted && props.isOldChatsLoading ? (
          <div className='ended-chats-loader'>
            <img src={Loader} alt='loader' />
          </div>
        ) : null}
        {isBackToTopVisible ? (
          <div className='back-to-top' onClick={backToTop}>
            <img src={BackToTop} alt='Back to top' />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default EndedChats;
